import axiosInstance from '../utils/axiosInstance';
import type { Matter, UpdateMatterInput } from '../../types/matter';

interface UpdateMatterResponse {
  success: boolean;
  data: { matter: Matter };
}

export const updateMatter = async (matterId: string, updates: UpdateMatterInput): Promise<Matter> => {
  const response = await axiosInstance.post<UpdateMatterResponse>(`/matters/${matterId}/update`, updates);
  return response.data.data.matter;
};
